<template>
  <div class="upload-container"  :class="{'hide-upload':maxNumber===_value.length}">

    <el-upload accept="image/*" action="#" 
      :limit="maxNumber" 
      :file-list="_value" 
      with-credentials 
      :auto-upload="true" 
      :multiple="maxNumber > 1" 
      list-type="picture-card"
      :before-upload="beforeUpload" :http-request="uploadFile" 
      class="upload-con">
      <i slot="default" v-if="loading" class="el-icon-loading primary-color"></i>
      <i slot="default" v-else class="el-icon-plus"></i>
      <div slot="file" slot-scope="{ file }" class="upload-file" >
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" fit="contain" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>

const qiniu = require('qiniu-js');
export default {
  name: 'imageUpload',
  components: {},
  props: {
    imgList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    maxSize: {
      type: Number,
      default: 5,
    },
    maxNumber: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    _value: {
      get: function () {
        return this.imgList;
      },
      set: function (e) {
        console.log('>>', e)
        this.$emit("uploadImg", e);
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      QiniuToken: '',
      loading:false
    };
  },
  methods: {
    beforeUpload(file) {
      const alows = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'];
      if (alows.indexOf(file.type) === -1) {
        this.$message.warning('存在不支持的图片格式');
      } else if (this.maxSize > 0 && file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`单张图片最大不超过 ${this.maxSize}MB`);
      } else {
        
        this.$api.qiniuToken().then(res => {
          if (res.code === 0) {
            this.QiniuToken = res.data
            this.uploadFile(file)
          }
        });

      }
      return false;
    },
    async uploadFile(file) {
      this.loading = true;
      console.log('uploadFile>>', file)
      const putExtra = {
        fname: file.name,//文件原文件名
        params: {},//用来放置自定义变量
        mimeType: ["image/png", "image/jpeg", "image/gif"],//用来限定上传文件类型，指定null时自动判断文件类型。
      }
      const config = {
        useCdnDomain: true,//表示是否使用 cdn 加速域名，为布尔值，true 表示使用，默认为 false。
      }
      const key = "oaWebPC/" + this.generateUUID();
      const observable = qiniu.upload(file, key, this.QiniuToken, putExtra, config)
      let that = this
      const subscription = observable.subscribe({
        next(res) {
          // console.log('next>>', res)
          // that.$message.warning('网络错误，请重新上传')
        },
        error(err) {
          that.$message.warning('网络错误，请重新上传')
          that.loading = false
        },
        complete(res) {
          // console.log('complete>>', res)
          that.loading = false
          console.log('https://fenxiao.muruji.com/' + res.key)
          let url = 'https://fenxiao.muruji.com/' + res.key
          let obj = {
            url,
            name: file.name,
            uid: file.uid
          }
          that._value.push(obj); //成功过后手动将文件添加到展示列表里
          that.$emit('uploadImg', that._value);
        },
      })
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      // 删除数组对象中的file对象
      this._value.splice(this._value.indexOf(file), 1)
      this.$emit('uploadImg', this._value);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-container {
  line-height: 1;
}


/deep/ .el-upload--picture-card {
  width: 64px;
  height: 64px;
  line-height: 1;
  border-radius: 4px;
  border-style: solid;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  

  .el-icon-plus {
    font-size: 24px;
    color: #c0ccda;
  }
}

/deep/ .el-upload-list--picture-card {
  font-size: 0;
  .el-upload-list__item {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  margin:0 8px 0 0!important;
  transition: none;
  .upload-file {
    width: 62px;
    height: 62px;
    overflow: hidden;
  }

  .el-upload-list__item-thumbnail {
    object-fit: contain;
    display: block;
    width: 62px;
    height: 62px;
  }
}

}
.upload-con {
  display: flex;
}
.loading-con{
  width: 64px;
  height: 64px;
}
.hide-upload {
  line-height: 1;

  /deep/ {
    .el-upload {
      display: none;
    }
  }
}

.look-upload {
  padding-bottom: 6px;
  // margin-bottom: 6px;
}
.primary-color{
  color: #00B498;
}
</style>
